import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '~/modules/sharedModule';
import { LoginDefaultPageTemplateModule } from '~/pageTemplates/login/pageTemplateDefault/modules/pageTemplateDefaultModule';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        LoginDefaultPageTemplateModule
    ],
    exports: [
        CommonModule,
        SharedModule,
        LoginDefaultPageTemplateModule
    ]
})

export class SharedLoginPageModule {
}